import{isObject as r}from"@guildeducationinc/type-guards";import{areServices as e}from"../Services/Services.js";var i=function(i){return r(i)&&"services"in i&&e(i.services)};export{i as isServiceConfig};
//# sourceMappingURL=ServiceConfig.js.map
